export enum MenuBreadcrumbsColorEnum {
  /**Только серый */
  OnlyGray = "only-gray",
}
